// extracted by mini-css-extract-plugin
export default {"table":"Table_table__sPlxf","first":"Table_first__G8MgY","last":"Table_last__07t0Y","firstHead":"Table_firstHead__Lh1wG"};